import styled from "styled-components/macro";

export const PopUpBodyText = styled.div`
  margin-left: 1em;
  margin-right: 1em;
`;
